import RouterBuilder from '../core/router-builder';

import routes from './routes';
import Auth from '../modules/Auth/routes';

RouterBuilder.addRawRoutes(routes);
RouterBuilder.addRawRoutes(Auth);
